import React, { useMemo } from "react";
import Logo from "../img/27Aniversario.webp";
import { Box } from "@mui/material";
import ProgressBar from "./progressBar.jsx";

const SplashScreen = () => {
  const rotateStyles = useMemo(
    () => ({
      animation: "rotate 2s linear infinite",
      width: "25%",
      "@keyframes rotate": {
        from: {
          transform: "rotate(0deg)",
        },
        to: {
          transform: "rotate(360deg)",
        },
      },
    }),
    []
  );

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      height="90vh"
      width="100%"
    >
      <img
        src={Logo}
        alt="Logotipo CSLH"
        style={rotateStyles}
      />

      {/* Separación en porcentaje */}
      <Box
        sx={{
          marginTop: "3%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ProgressBar />
      </Box>
    </Box>
  );
};

export default SplashScreen;